/* eslint-disable babel/camelcase */
/* eslint-disable react/prefer-stateless-function */
import { __ } from '@wordpress/i18n';
import { Component, Fragment } from 'react';

import { ToggleControl } from '@wordpress/components';

import Text from 'Components/Text';
import Label from 'Components/Label';
import ThemeSelect, { themeOptions } from 'Components/ThemeSelect';
import Select from 'Components/Select';

import {
	getCurrentSelected,
	toggleAttributeBasedOnString,
	getToggleAttributeBoolValueBasedOnString,
	handleTopLevelInput,
} from 'Utils/helpers';

class Login extends Component {
	render() {
		const { attributes, setAttributes } = this.props;
		const { theme, style, redir, regurl, content, max_width } = attributes;
		const styles = [
			{
				label: __('Material Style', 'ipt_fsqm'),
				value: 'material',
			},
			{
				label: __('Boxy Style', 'ipt_fsqm'),
				value: 'boxy',
			},
		];

		return (
			<Fragment>
				<ThemeSelect
					value={getCurrentSelected(themeOptions, theme)}
					onChange={e => {
						setAttributes({ theme: e.value });
					}}
					title={__('Login Form Color Scheme', 'ipt_fsqm')}
				/>
				<Label title={__('Login Form Style', 'ipt_fsqm')}>
					<Select
						value={getCurrentSelected(styles, style)}
						options={styles}
						onChange={e => {
							setAttributes({ style: e.value });
						}}
					/>
				</Label>
				<Label title={__('Form Heading', 'ipt_fsqm')}>
					<Text
						value={content}
						onChange={e => handleTopLevelInput(e, setAttributes)}
						name="content"
						placeholder={__('keep empty to hide', 'ipt_fsqm')}
					/>
				</Label>
				<Label title={__('Redirect URL after login', 'ipt_fsqm')}>
					<Text
						value={redir}
						onChange={e => handleTopLevelInput(e, setAttributes)}
						name="redir"
						placeholder={__(
							'keep empty for current page',
							'ipt_fsqm'
						)}
					/>
				</Label>
				<Label title={__('Maximum width', 'ipt_fsqm')}>
					<Text
						value={max_width}
						onChange={e => handleTopLevelInput(e, setAttributes)}
						name="max_width"
						placeholder={__(
							'keep empty for current page',
							'ipt_fsqm'
						)}
					/>
				</Label>
				<Label title={__('Buttons', 'ipt_fsqm')}>
					<Fragment>
						<ToggleControl
							label={__('Show Registration button', 'ipt_fsqm')}
							checked={getToggleAttributeBoolValueBasedOnString(
								'register',
								attributes
							)}
							onChange={() => {
								toggleAttributeBasedOnString(
									'register',
									attributes,
									setAttributes
								);
							}}
						/>
						<ToggleControl
							label={__(
								'Show Forgot Password button',
								'ipt_fsqm'
							)}
							checked={getToggleAttributeBoolValueBasedOnString(
								'forgot',
								attributes
							)}
							onChange={() => {
								toggleAttributeBasedOnString(
									'forgot',
									attributes,
									setAttributes
								);
							}}
						/>
					</Fragment>
				</Label>
				{getToggleAttributeBoolValueBasedOnString(
					'register',
					attributes
				) ? (
					<Label title={__('Registration URL', 'ipt_fsqm')}>
						<Text
							value={regurl}
							onChange={e =>
								handleTopLevelInput(e, setAttributes)
							}
							name="regurl"
							placeholder={__(
								'keep empty for default wp register link',
								'ipt_fsqm'
							)}
						/>
					</Label>
				) : null}
			</Fragment>
		);
	}
}

export default Login;
